import React, { useState } from 'react';
import styled from 'styled-components';
import { colors, sizes, media, helpers } from 'styles/variables';
import { logo } from 'styles/vectors';
import { log } from 'utils/log';

export default props => {
	const lang = props.pageContext.lang || '';
	const [header] = useState(require(`data/${lang}_header`));

	const StyledWrapper = styled.div`
		${media.small}{
			${lang === 'keto' &&
				`
					background:rgba(0,0,0,0.45);
					box-shadow: 0 0 10px 10px rgba(0,0,0,0.45);
				`}
			}
		}
		z-index: 9;
		position:fixed;
		top:0;
		left:0;
		right:0;
		display: grid;
		grid-template-columns: auto 1fr;
		grid-gap ${sizes[1]};
		padding: ${sizes[1]};
		align-items: center;
		${props.dark === true &&
			`
			background: #10120c;
		`}
		${props.fixed === true && `position:fixed;top:0;left:0;right:0;`};
		${media.small} {
			font-size: 0.9rem;
		}
	`;
	const Logo = styled.div`
		text-align: left;
		svg {
			height: 44px;
			${media.small} {
				height: 34px;
			}
			width: auto;
			.fill1 {
				fill: ${colors.background[0]};
			}
			.fill2 {
				fill: ${colors.brand.base};
			}
			.fill3 {
				fill: ${colors.brand.dark};
			}
			${props.dark === true &&
				`
				.fill1 {
					fill: ${colors.background[0]};
				}
				.fill2 {
					fill: ${colors.teal.base};
				}
				.fill3 {
					fill: ${colors.brand.light};
				}
			`}
		}
	`;
	const Nav = styled.div`
		text-align: right;
		font-weight: 600;
		text-transform: capitalize;
		a {
			padding: ${sizes[1]};
			${media.small} {
				padding: ${sizes[1]};
				font-size: 0.85rem;
			}
			color: ${colors.foreground[1]};
			&:hover {
				color: ${colors.brand.base};
			}
			${props.dark === true &&
				`
				color:${colors.background[1]}
			`}
		}
	`;

	return (
		<>
			<StyledWrapper>
				<Logo
					onClick={() => {
						log('Interaction', 'Header', 'click--logo');
					}}
				>
					<a href="/" className="headerLogo">
						{logo}
					</a>
				</Logo>
				<Nav>
					{header.map((item, index) => (
						<a
							key={index}
							href={item.link}
							className="headerLink"
							onClick={() => {
								log('Interaction', 'HeaderSimple', `click--${item.link}`);
							}}
						>
							{item.title}
						</a>
					))}
				</Nav>
			</StyledWrapper>
		</>
	);
};
